import React, { Component } from "react";
import { profile, branch, alert, total, float, toFixed, format_date, random_charactor, GET, POST, PUT, DELETE, loading, Status, params, required, DatePicker, Select, BtnIcon, Swal, Pagination, Switch, Navbar, Modal, Resizer } from "../../components/CustomComponent.js";
export default class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
    };
  }

  async componentDidMount() {
    loading(false);
    await this.Get(1);
  }
  Get = async (page) => {
    loading(true);
    let result = await GET("admin/manage/customers/list", null);
    if (result?.status) {
      this.setState({ data: result.data, count: result.count });
    }
    loading(false);
  };
  render() {
    return (
      <div className="w-100 min-vh-100 bg-light">
        <Navbar />
        <div className="body p-3">
          <h3 className="fw-bold mb-3">แดชบอร์ด</h3>
          <div className="row">
            <div className="col-12 col-md-6 col-lg-3 mb-3">
              <div className="rounded-4 p-3 d-flex justify-content-between bg-white shadow">
                <div>
                  <div className="text-secondary">ชาวไร่</div>
                  <h3 className="fw-bold mb-0">53,000</h3>
                  <small className="text-secondary">+55%</small>
                </div>
                <span className="icon wpx-40 hpx-40 rounded-4 bg-primary text-white d-flex align-items-center justify-content-center">{"\uf007"}</span>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-3 mb-3">
              <div className="rounded-4 p-3 d-flex justify-content-between bg-white shadow">
                <div>
                  <div className="text-secondary">พื้นที่ทั้งหมด (ไร่)</div>
                  <h3 className="fw-bold mb-0">53,000</h3>
                  <small className="text-secondary">+55%</small>
                </div>
                <span className="icon wpx-40 hpx-40 rounded-4 bg-primary text-white d-flex align-items-center justify-content-center">{"\uf0db"}</span>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-3 mb-3">
              <div className="rounded-4 p-3 d-flex justify-content-between bg-white shadow">
                <div>
                  <div className="text-secondary">อ้อยปลูก (ไร่)</div>
                  <h3 className="fw-bold mb-0">53,000</h3>
                  <small className="text-secondary">+55%</small>
                </div>
                <span className="icon wpx-40 hpx-40 rounded-4 bg-primary text-white d-flex align-items-center justify-content-center">{"\uf4d8"}</span>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-3 mb-3">
              <div className="rounded-4 p-3 d-flex justify-content-between bg-white shadow">
                <div>
                  <div className="text-secondary">อ้อยตอ (ไร่)</div>
                  <h3 className="fw-bold mb-0">53,000</h3>
                  <small className="text-secondary">+55%</small>
                </div>
                <span className="icon wpx-40 hpx-40 rounded-4 bg-primary text-white d-flex align-items-center justify-content-center">{"\uf1bb"}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
